import React from "react";
import PickMeals from "../Assets/pick-meals-image.png";
import ChooseMeals from "../Assets/choose-image.png";
import DeliveryMeals from "../Assets/delivery-image.png";

const Work = () => {
  const workInfoData = [
    {
      image: DeliveryMeals,
      title: "In-House Delivery",
      text: "Enjoy our swift in-house delivery service, ensuring your favorite meals arrive hot and fresh right to your doorstep.",
    },
    {
      image: PickMeals,
      title: "Pick Up from Cafe",
      text: "Prefer to dine in? Easily pick up your order directly from our cafe at your convenience and savor it on the spot.",
    },
    {
      image: ChooseMeals,
      title: "Order Online",
      text: "Order effortlessly through our online platforms and have your delicious food delivered quickly and reliably.",
    },
  ];

  return (
    <div className="work-section-wrapper">
      <div className="work-section-top">
        <p className="primary-subheading">Work</p>
        <h1 className="primary-heading">How It Works</h1>
        <p className="primary-text">
          Discover the seamless ways to enjoy our delicious offerings. Whether you choose delivery, pick-up, or ordering online, we ensure a delightful experience every step of the way.
        </p>
      </div>
      <div className="work-section-bottom">
        {workInfoData.map((data) => (
          <div className="work-section-info" key={data.title}>
            <div className="info-boxes-img-container">
              <img src={data.image} alt={data.title} />
            </div>
            <h2>{data.title}</h2>
            <p>{data.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Work;
